export enum ServiceType {
  SECURITY = 'SECURITY',
  WEB_DEV = 'WEB_DEV',
  NONE = 'NONE'
}

export interface NavItem {
  label: string;
  path: string;
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Home', path: '/' },
  { label: 'Strategy', path: '/strategy' },
  { label: 'Security', path: '/security' },
  { label: 'Web Dev', path: '/web-dev' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];